import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { SellingADogScreen, SellingADogScreenProps } from 'shared/screens/selling-a-dog';
import { withServerProps } from '@web/library/with-server-props';

export default function SellingADog(props: SellingADogScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) => seo.forPage(t('selling_a_dog.title'), t('selling_a_dog.description'))}
    >
      <SellingADogScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(SellingADogScreen.pageBuilder);
